module.exports = function () {
  for (var r = [], n = arguments.length; n--;) {
    r[n] = arguments[n];
  }

  return function () {
    for (var n = [], t = arguments.length; t--;) {
      n[t] = arguments[t];
    }

    var e = r.length - 1;

    for (n = r[e].apply(r, n); e--;) {
      n = r[e](n);
    }

    return n;
  };
};